module.exports = __webpack_public_path__ + "static/sitefinity-e71d7451a9aff3f1b060be5ce69a6cf1.png";